import { apiConstructor as api } from '@/api/apiConstructor';
import { AxiosResponse } from 'axios';
import { Menu, MenuItem } from '@/types/menus';

export async function getMenu(id: string): Promise<any> {
  try {
    const response: AxiosResponse = await api.get(`menus/${id}`);
    return response.data;
  } catch (error) {
    return error.data;
  }
}

export async function getMenus(): Promise<any> {
  try {
    const response: AxiosResponse = await api.get('menus');
    return response.data;
  } catch (error) {
    return error.data;
  }
}

export async function saveMenu(menu: Menu): Promise<Menu> {
  const url: string = menu.id === undefined ? 'menus' : `menus/${menu.id}`;

  try {
    const response: AxiosResponse =
      menu.id === undefined
        ? await api.post(url, { ...menu })
        : await api.put(url, { ...menu });
    return response.data;
  } catch (error) {
    return error.data;
  }
}

export async function saveMenuItem(menuItem: MenuItem): Promise<MenuItem> {
  const url: string =
    menuItem.id === undefined ? 'menu-items' : `menu-items/${menuItem.id}`;

  try {
    const response: AxiosResponse =
      menuItem.id === undefined
        ? await api.post(url, { ...menuItem })
        : await api.put(url, { ...menuItem });
    return response.data;
  } catch (error) {
    return error.data;
  }
}

export async function saveMenuItemOrder(sortOrder: any[]): Promise<Menu> {
  try {
    const response: AxiosResponse = await api.put('menu-items/resort', {
      ...sortOrder,
    });
    return response.data;
  } catch (error) {
    return error.data;
  }
}

export async function deleteMenuItem(menuItem: MenuItem): Promise<MenuItem> {
  try {
    const response: AxiosResponse = await api.delete(
      `menu-items/${menuItem.id}`,
    );
    return response.data;
  } catch (error) {
    return error.data;
  }
}
